import { OnLottieError, LOTTIE_ERROR_TYPES } from "@swiggy-private/core-types";
import { getCloudinaryUrl, isEmpty } from "@swiggy-private/js-utils";

export const fetchLottieAsset = async (id: string, onError: OnLottieError): Promise<string | null> => {
    if (isEmpty(id)) {
        onError(LOTTIE_ERROR_TYPES.ASSET_FETCH_ERROR, "Invalid asset id");
        return null;
    }

    try {
        const url = getCloudinaryUrl(id);

        if (isEmpty(url)) {
            onError(LOTTIE_ERROR_TYPES.ASSET_FETCH_ERROR, "Invalid asset url");
            return null;
        }

        const response = await fetch(url);
        const blob = await response.blob();
        return URL?.createObjectURL?.(blob);
    } catch (error) {
        onError(LOTTIE_ERROR_TYPES.ASSET_FETCH_ERROR, error);
        return null;
    }
};
